import React, { forwardRef, useCallback } from 'react';
import { Alert } from '@mui/material';
import { useSnackbar } from 'notistack';

/**
 * Custom notistack snackbar that renders as a MUI Alert.
 * Registered via SnackbarProvider's Components prop.
 */
export const AlertSnackbar = forwardRef(({ id, message, variant, ...rest }, ref) => {
  const { closeSnackbar } = useSnackbar();
  const handleClose = useCallback(() => closeSnackbar(id), [id, closeSnackbar]);

  return (
    <Alert
      ref={ref}
      onClose={handleClose}
      severity={variant || 'info'}
      variant="filled"
      sx={{
        fontSize: '0.95rem',
        minWidth: 300,
        maxWidth: 500,
        alignItems: 'center',
      }}
      {...rest}
    >
      {message}
    </Alert>
  );
});

AlertSnackbar.displayName = 'AlertSnackbar';
